import { createContext } from 'react';

var defaultValue = {
  triggerRef: null,
  state: {
    isOpen: false,
    setOpen: function setOpen() {},
    focusStrategy: 'focus',
    open: function open() {},
    close: function close() {},
    toggle: function toggle() {}
  }
};
var SelectContext = /*#__PURE__*/createContext(defaultValue);

export { SelectContext };
//# sourceMappingURL=SelectContext.js.map
